import Data from './data'
import Vue from 'vue'
import Vuex from 'vuex'
import loadWasmModule from './wasm.js';

Vue.use(Vuex)

function namesToIndexList(columnNames, columns) {
    return columnNames.map(name => columns.indexOf(name))
}


const store = {
    state: {
        data: null,
        selection: null,
        module: null,
        error: null,
        dirtySelection: false,
        settings: {
            activatePan: false,
            activateZoom: false,
            gradientScope: true, // true is per-axis, false is global
            nodeView: true // true is histogram, false is line
        }
    },
    mutations: {
        invertSelection(state) {
            // TODO Set state to pending
            state.module.invertSelection();
        },
        changeTool(state, tool) {
            if (tool === 'clickSelection') {
                state.module.changeMode(10);
            } else if (tool === 'invertAxis') {
                state.module.changeMode(20);
            } else if (tool === 'moveAxes') {
                state.module.changeMode(30);
            } else if (tool === 'deleteAxes') {
                state.module.changeMode(40);
            } else if (tool === 'insertAxes') {
                state.module.changeMode(50);
            } else if (tool === 'rescale') {
                state.module.changeMode(60);
            } else if (tool === 'picker') {
                state.module.changeMode(80);
            } else if (tool === 'edgeLookAndFeel') { // TODO
                state.module.changeMode(90);
            } else if (tool === 'sliderSelection') {
                state.module.changeMode(70);
            } else if (tool === 'variationSelection') {
                state.module.changeMode(100);
            }
        },
        wasm(state) {
            state.module = loadWasmModule();
            state.module.onEvent = event => {
                if (event === 1) {
                    const s = state.module.getHighlight();
                    state.selection = [];
                    state.dirtySelection = false;
                    for (let i = 0; i < s.size(); i++) {
                        state.selection.push(s.get(i));
                    }
                } else if (event === 2) {
                    state.dirtySelection = false;
                    state.selection = null;
                } else {
                    console.log(event);
                }
            };
            state.module.onWheelParameterChange = () => {
                // TODO handle argument change on futur sliders
            }
        },
        updateSettings(state, ns) {
            const s = state.settings
            const panZoomChange = (ns.activatePan && s.activatePan !== ns.activatePan) ||
                (ns.activateZoom && s.activateZoom !== ns.activateZoom)
            if (panZoomChange) {
                state.module.togglePanOrZoom(ns.activatePan, ns.activateZoom)
            }
            if (Object.prototype.hasOwnProperty.call(ns, 'gradientScope') && s.gradientScope != ns.gradientScope) {
                state.module.changeGradientScope()
            }
            if (Object.prototype.hasOwnProperty.call(ns, 'nodeView') && s.nodeView != ns.nodeView) {
                state.module.changeInnerNodeView()
            }
            if (Object.prototype.hasOwnProperty.call(ns, 'verticalMapping') && s.verticalMapping != ns.verticalMapping) {
                state.module.changeMapping()
            }
            state.settings = {...state.settings, ...ns};
        },
        resize(state) {
            if (state.module)
                state.module.onResize();
        },
        fit(state) {
            if (state.module)
                state.module.fit();
        },
        center(state) {
            if (state.module)
                state.module.center();
        }
    },
    actions: {
        loadDataset({state}, {input, options, processing}) {
            state.selection = null; // Clear previous dataset
            return new Promise((resolve, reject) => {
                state.data = new Data(input, options, (stringifiedDataset, fields) => {
                    const options = state.data.options;
                    try {
                        state.module.loadData(
                            stringifiedDataset,
                            false,
                            namesToIndexList(options.ordinalDimensions, fields).join(','),
                            namesToIndexList(options.nominalDimensions, fields).join(','),
                            '',
                            parseFloat(options.minValue) || Infinity,
                            parseFloat(options.maxValue) || Infinity,
                            options.withHeader || false,
                            false,
                            parseInt(processing.nbClusters, 10),
                            parseInt(processing.clustering, 10),
                            options.delimiter);
                        state.module.onResize()
                        resolve();
                    } catch (e) {
                        reject(e);
                    }
                });
            });
        }
    },
    getters: {
        dataLoaded: state => {
            return state.data !== null;
        },
        getSettings: state => {
            return state.settings;
        },
        nbIndividuals: state => {
            if (!state.data) {
                return undefined;
            }
            return state.data.nbIndividuals();
        },
        dataSummary: state => {
            if (!state.data) {
                return undefined;
            }
            return state.data.nbIndividuals() + ' items and ' + (state.data.nbColumns()) + ' columns';
        },
        nbColumns: state => {
            if (!state.data) {
                return undefined;
            }
            return state.data.nbColumns();
        },
        loadingProgress: state => {
            if (!state.data) {
                return 0;
            }
            return state.data.getProgress();
        },
        activeSelection: state => {
            return state.selection !== null;
        },
        getSelection: state => {
            // TODO filter dimensions, save current selection (save refilter)
            if (state.selection)
                return state.data.filterTable(state.selection);
            return []
        },
        getDataTable: state => {
            // TODO filter dimensions?
            if (state.data)
                return state.data.table;
            return []
        },
        getDeletedDimensions: state => {
            if (state.module && state.module.running) {
                let deleted = state.module.getDeletedDimensions()
                let result = [...Array(deleted.size()).keys()].map(i => {
                    return {
                        index: deleted.get(i),
                        label: state.module.getDimensionLabel(deleted.get(i))
                    }
                });
                deleted.delete();
                return result
            }
            return []
        }
    }
};

export default store;
